import type { FC, SVGProps } from "react";

const IconFreeParking: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1 17V9C1 8.46957 1.21071 7.96086 1.58579 7.58579C1.96086 7.21071 2.46957 7 3 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 7V3C3 2.46957 3.21071 1.96086 3.58579 1.58579C3.96086 1.21071 4.46957 1 5 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 1V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 15H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeParking;
